import React, { useEffect, useState, useContext } from "react";
import DashboardHeader from "./DashboardHeader/DashboardHeader";
import DashboardHero from "./DashboardHero/DashboardHero";
import "./dashboard.css";
import CollapseBlock from "./CollapseBlockLeft/collapseblockleft";
import CollapseBlockRight from "./collapseblockright/collapseblockright";
import { UserContext } from "../../utils/contexts/UserContext";
import { allGames, allUsers } from "../games/auxiliary/gamesAux";
import CustomSvg from "../svgs/CustomSvg";
import { useNavigate } from "react-router-dom";
import { IoMdNotifications } from "react-icons/io";
import { GrTransaction } from "react-icons/gr";
import { FaTrophy } from "react-icons/fa";
import WithdrawModal from "../payments/WithdrawModal";
import { Offcanvas, Modal } from "react-bootstrap";
import ComingSoonModal from "../common/ComingSoonModal";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { LuUser } from "react-icons/lu";
import { HiUsers } from "react-icons/hi";
import { IoChatbox, IoChatbubble, IoLockClosed } from "react-icons/io5";
import { BsBank } from "react-icons/bs";
import { GoInfo } from "react-icons/go";
import { getRequest, postRequest } from "../apiRequests/requestApi";
import avatar from "../../assets/images/userProfile3.png";
import { useGames } from "../../utils/hooks";
import GameResultModal from "../games/GameResult";
import GameRating from "../games/GameRating";
import ludo from "../../assets/images/orig 1.svg";
import Coin from "../../assets/images/coin.svg";



const bgColors = [
  "bg-[#D9D9D9]/10",
  "bg-[#D9D9D9]/10",
  "bg-[#D9D9D9]/10",
  "bg-[#D9D9D9]/10",
];
const gamerColors = [
  "bg-red-500",
  "bg-green-500",
  "bg-blue-500",
  "bg-yellow-500",
  "bg-purple-500",
];


const navLinks = [
  {
    name: "user info",
    path: "user-profile",
    Icon: () => <LuUser size={18} color="#6499FF" />,
  },
  {
    name: "invite friends",
    path: "invite-friends",
    Icon: () => <HiUsers size={18} color="#6499FF" />,
  },

  {
    name: "security",
    path: "security",
    Icon: () => <IoLockClosed size={18} color="#6499FF" />,
  },
  {
    name: "Add BANK",
    path: "add-bank",
    Icon: () => <BsBank size={18} color="#6499FF" />,
  },
  {
    name: "help",
    path: "help",
    Icon: () => <GoInfo size={18} color="#6499FF" />,
  },
];

function useIsMobile() {
  if (typeof window === "undefined") return false;
  return window.innerWidth <= 768;
}

function MobileHeader({ user, userLogout, accountType }) {
  const navigate = useNavigate();
  const [showOffCanvasNav, setShowOffCanvasNav] = useState(false);

  const openOffCanvasNav = () => setShowOffCanvasNav(true);
  const closeOffCanvasNav = () => setShowOffCanvasNav(false);
  const iconColor = accountType === "celebrity" ? "#3F7227" : "#BE3593";

  return (
<div className="bg-[#130828] fixed z-20 top-0 mb-24 left-0 w-full p-3 flex justify-between items-center">
      {/* Left: Avatar & Greeting */}
      <div className="flex items-center gap-3">
        <img
          src={user?.avatar || avatar}
          alt="User avatar"
          // onClick={openOffCanvasNav}
          className={`w-10 h-10 rounded-full object-cover cursor-pointer border-2  ${
            accountType === "celebrity"
              ? "border-[#3F7227]"
              : "border-[#BE3593]"
          }`}
        />
        <div>
          <div className="text-white text-sm font-medium">
            Hello{" "}
            <span className="capitalize">
              {user?.username || "User"}
            </span>
          </div>
          <div className="text-gray-400 text-xs">Welcome back</div>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate("/transaction-history")}
          className="p-2 rounded-full hover:bg-gray-800 transition-colors"
          aria-label="Transaction History"
        >
          <GrTransaction size={18} color={iconColor} />
        </button>
        <button
          onClick={() => navigate("/notifications")}
          className="p-2 rounded-full hover:bg-gray-800 transition-colors"
          aria-label="Notifications"
        >
          <IoMdNotifications size={18} color={iconColor} />
        </button>
      </div>

      {/* Offcanvas Navigation */}
      <Offcanvas show={showOffCanvasNav} onHide={closeOffCanvasNav}>
        <div className="bg-[#130828] w-full h-full">
          <div className="flex flex-col h-full p-4">
            {/* Header */}
            <div className="flex justify-end items-end mb-6">
              <button
                onClick={closeOffCanvasNav}
                className="cursor-pointer"
                aria-label="Close menu"
              >
                <CustomSvg name="x" color="#FFF" />
              </button>
            </div>

            {/* Content Area: Links + Logout */}
            <div className="flex flex-col justify-between flex-1 overflow-y-auto">
              {/* Nav Links */}
              <div className="space-y-2">
                {navLinks.map(({ name, path, Icon }, i) => {
                  const handleClick = () => {
                    closeOffCanvasNav();
                    navigate(
                      path === "user-profile"
                        ? `/${path}`
                        : `/user-profile/${path}`
                    );
                  };

                  return (
                    <button
                      key={i}
                      onClick={handleClick}
                      className="w-full flex items-center p-3 rounded-lg hover:bg-gray-700 transition text-left"
                    >
                      <div className="bg-gray-800 p-2 rounded-lg">
                        <Icon />
                      </div>
                      <p className="ml-4 text-white text-sm font-medium capitalize font-poppins">
                        {name}
                      </p>
                    </button>
                  );
                })}
              </div>

              {/* Logout */}
              <div className="mt-6 pt-4 border-t border-gray-700 pb-10">
                <button
                  onClick={() => {
                    closeOffCanvasNav();
                    userLogout();
                  }}
                  className="w-full flex items-center p-3 rounded-lg hover:bg-gray-700 transition text-left"
                  aria-label="Logout"
                >
                  <div className="bg-gray-800 p-2 rounded-lg">
                    <RiLogoutBoxRLine size={18} color="#FF1843" />
                  </div>
                  <p className="ml-4 text-white text-sm font-medium capitalize font-poppins">
                    Logout
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Offcanvas>
    </div>
  );
}

function BalanceCard({ user, accountType }) {
  const [withdrawModal, setWithdrawModal] = useState({
    visible: false,
    onHide: null,
    size: "md",
    amount: 0,
  });
  const [showDepositInfo, setShowDepositInfo] = useState(false);
  const [showWithdrawInfo, setShowWithdrawInfo] = useState(false);
  const [selectedWithdrawAmount, setSelectedWithdrawAmount] = useState(1000);
  const navigate = useNavigate();
  const openWithdrawModal = () => setShowWithdrawInfo(true);
  const closeWithdrawModal = () => setShowWithdrawInfo(false);
  const [selectedWithdraw, setSelectedWithdraw] = useState(0);
  const [showWithdraw, setShowWithdraw] = useState(false); // Old modal state
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [comingSoonFeature, setComingSoonFeature] = useState("");
  const [selectedAmount, setSelectedAmount] = useState(0);
  const maskAccountNumber = (accountNumber) => {
    if (!accountNumber || accountNumber.length < 7)
      return accountNumber || "No bank account";
    return `${accountNumber.slice(0, 3)}****${accountNumber.slice(-3)}`;
  };
  const [apiReqs, setApiReqs] = useState({
    isLoading: false,
    errorMsg: null,
  });
const initiateDeposit = (amount) => {
    setApiReqs({ isLoading: true, errorMsg: null });

    return onDeposit(amount);
  };

  const onDeposit = async (amount) => {
    try {
      setApiReqs({ isLoading: true, errorMsg: null });
      const amountinnaira = amount / 100; // Convert kobo to naira
      // Simulate fetching bank transfer details from backend
      // Replace this with your actual API call if needed
      const showCharge = amountinnaira >= 10000;
      const displayAmount = showCharge ? amountinnaira + 50 : amountinnaira;
      const bankDetails = {
        accountNumber: "6868308433",
        accountName: "SKYBOARD GAMES LIMITED",
        bankName: "Moniepoint MFB",
        amount: displayAmount, // Only for display
      };

      // Show a div with the transfer details
      const depositDiv = document.createElement("div");
      depositDiv.style.position = "fixed";
      depositDiv.style.top = "0";
      depositDiv.style.left = "0";
      depositDiv.style.width = "100vw";
      depositDiv.style.height = "100vh";
      depositDiv.style.background = "rgba(0,0,0,0.7)";
      depositDiv.style.display = "flex";
      depositDiv.style.alignItems = "center";
      depositDiv.style.justifyContent = "center";
      depositDiv.style.zIndex = "9999";

      depositDiv.innerHTML = `
          <div style="background:linear-gradient(135deg,#000 60%,#4ade80 100%); color:#fff; border-radius:20px; padding:36px 24px; max-width:370px; width:100%; box-shadow:0 8px 32px rgba(0,0,0,0.35); font-family:'Poppins',sans-serif; text-align:center; position:relative; border:2px solid #4ade80;">
            <button id="closeDepositDiv" style="position:absolute; color:#fff; top:12px; right:12px; background:rgba(0,0,0,0.08); border:none; font-size:1.7rem; cursor:pointer; border-radius:50%; width:36px; height:36px; display:flex; align-items:center; justify-content:center;">&times;</button>
            <img src="https://th.bing.com/th/id/R.9f3ac48b9a811711607dede999a4dd6e?rik=lk25VYxnCFf5lw&pid=ImgRaw&r=0" alt="Moniepoint Logo" style="height:40px; margin-bottom:16px; background:none; border-radius:8px;" />
            <div style="font-weight:bold; color:#4ade80; margin-bottom:14px; font-size:1.1rem; letter-spacing:1px;">BANK TRANSFER</div>
            <div style="display:flex; align-items:center; justify-content:center; gap:10px; font-size:1.15rem; letter-spacing:1px; margin-bottom:8px; color:#fff; font-weight:500;">
              <span style="font-family:'Fira Mono',monospace; font-size:1.15rem;">${
                bankDetails.accountNumber
              }</span>
              <button id="copyAcctBtn" style="background:linear-gradient(90deg,#4ade80,#6499FF); color:#18122B; border:none; border-radius:6px; padding:4px 14px; font-weight:700; cursor:pointer; font-size:0.98rem; box-shadow:0 2px 8px rgba(76,222,128,0.08); transition:background 0.2s;">COPY</button>
            </div>
            <div style="margin-bottom:6px; color:#fff; font-size:1rem; font-weight:500;">${
              bankDetails.accountName
            }</div>
            <div style="margin-bottom:14px; color:#bfc9d8; font-size:0.98rem;">${
              bankDetails.bankName
            }</div>
            <div style="font-size:1.25rem; font-weight:700; margin-bottom:10px; color:#4ade80;">₦${bankDetails.amount.toLocaleString(
              undefined,
              { minimumFractionDigits: 2 }
            )}</div>
            ${
              showCharge
                ? '<div style="color:#e11d48; font-size:0.97rem; margin-bottom:10px;">₦50 charge included for deposits above ₦10,000</div>'
                : ""
            }
            <button id="transferredBtn" style="background:linear-gradient(90deg,#6499FF,#4ade80); color:#fff; border:none; border-radius:8px; padding:10px 0; width:100%; font-weight:700; font-size:1.08rem; margin-top:10px; box-shadow:0 2px 8px rgba(100,153,255,0.08); cursor:pointer;">I HAVE TRANSFERRED</button>
          </div>
        `;

      document.body.appendChild(depositDiv);

      depositDiv.querySelector("#closeDepositDiv").onclick = () => {
        document.body.removeChild(depositDiv);
      };

      depositDiv.querySelector("#copyAcctBtn").onclick = () => {
        navigator.clipboard.writeText(bankDetails.accountNumber);
        depositDiv.querySelector("#copyAcctBtn").innerText = "COPIED!";
        setTimeout(() => {
          depositDiv.querySelector("#copyAcctBtn").innerText = "COPY";
        }, 1200);
      };


      depositDiv.querySelector("#transferredBtn").onclick = async () => {
        depositDiv.querySelector("#transferredBtn").disabled = true;
        depositDiv.querySelector("#transferredBtn").innerText = "Processing...";
        try {
          const response = await postRequest({
            url: "/payment/manual-deposit",
            data: { amount: amount }, // Only send original amount
          });
          if (!response.success) {
            throw new Error(response.message || "Manual deposit failed");
          }
          document.body.removeChild(depositDiv);
          alert("Deposit request sent!");
        } catch (error) {
          depositDiv.querySelector("#transferredBtn").disabled = false;
          depositDiv.querySelector("#transferredBtn").innerText =
            "I HAVE TRANSFERRED";
          alert(error.message || "Manual deposit failed");
        }
      };

      setApiReqs({ isLoading: false, errorMsg: null });
    } catch (error) {
      setApiReqs({
        isLoading: false,
        errorMsg: error.message || "Failed to process deposit",
      });
    }
  };
  const handleShowComingSoon = (feature) => {
    setComingSoonFeature(feature);
    setShowComingSoon(true);
  };

  return (
    <>
      <div
        className={`p-4 mt-20 rounded-2xl text-white shadow-lg bg-gradient-to-r ${
          accountType === "celebrity"
            ? "from-[#5A43E2] to-[#3F7227]"
            : "from-[#6499FF] to-[#BE3593]"
        } sm:p-3 xs:p-2`}
      >
        <div className="text-sm text-white font-medium mb-1">Total Amount</div>

        <div className="text-3xl font-medium mb-2 flex items-center gap-1">
          <img src={Coin} alt="coin" className=" inline-block align-middle mr-1" />
          {/* {(Math.round(user?.walletBalance) / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} */} 
         {(user?.walletBalance / 100).toLocaleString()} 
            
        </div>

        <div className="flex items-center gap-3">
          <button
            className="bg-white transition text-black p-1.5 rounded-md font-semibold"
            onClick={() => setShowDepositInfo(true)}
          >
            <span className="hidden min-[390px]:inline">+ Inject Tokens</span>
            <span className="inline min-[390px]:hidden px-2">Inject</span>
          </button>
          <button
            className="border border-gray-500 hover:border-gray-300 text-gray-300 hover:text-white p-1.5 rounded-md font-semibold transition"
            onClick={openWithdrawModal}
          >
            <span className="hidden min-[390px]:inline">- Reedem Tokens</span>
            <span className="inline min-[390px]:hidden px-2">Redeem</span>
          </button>
        </div>
      </div>

      {/* Deposit Info Modal */}
     <Modal
  show={showDepositInfo}
  onHide={() => setShowDepositInfo(false)}
  fullscreen
  centered
  dialogClassName="bg-[#130828] custom-modal"
>
  {/* Header */}
  <Modal.Header closeButton className="bg-[#130828] border-none">
    <Modal.Title className="flex items-center justify-between w-full">
      <span className="text-white text-xl font-bold">Deposit</span>
      <div className="flex items-center gap-2 bg-[#2E1243] rounded-full py-2 px-6 text-lg font-bold ml-4">
        <img src={Coin} alt="coin" className="w-5 h-5" />
        <span className="text-white">
          {(Math.round(user?.walletBalance) / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      </div>
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="bg-[#130828] text-white min-h-[70vh] flex flex-col items-center">
    <div className="w-full max-w-md px-4 sm:px-2 xs:px-1">
      {/* Game Image */}
      <img src={ludo} alt="Ludo Classic" className="rounded-lg w-full mb-6" />

      {/* Deposit Amount Buttons */}
      <div className="grid grid-cols-3 gap-4 text-center sm:gap-2 xs:gap-1">
        {[
          { amount: 100000, bonus: 500 },
          { amount: 50000, bonus: 250 },
          { amount: 20000, bonus: 100 },
          { amount: 10000, bonus: 50 },
          { amount: 5000, bonus: 25 },
          { amount: 2000, bonus: 10 },
          { amount: 1000, bonus: 5 },
          { amount: 500 },
          { amount: 200 },
        ].map(({ amount, bonus }) => (
          <div
            key={amount}
            className={`relative bg-[#1F0A35] border border-[#BD3193] rounded-xl px-2 py-4 font-semibold cursor-pointer ${
              selectedAmount === amount ? "ring-2 ring-[#BD3193]" : ""
            } sm:px-1 sm:py-3 xs:px-0.5 xs:py-2`}
            onClick={() => setSelectedAmount(amount)}
          >
            {bonus && (
              <div className="absolute top-0 right-0 -mt-2 -mr-2 bg-[#BD3193] text-white text-[10px] font-bold px-2 py-1 rounded-full">
                +{bonus}
              </div>
            )}
            <div className="flex items-center justify-center ">
              <img
                src={Coin}
                alt="coin"
                className="w-5 h-5 inline-block align-middle mr-1"
              />
              {amount.toLocaleString()}
            </div>
          </div>
        ))}
      </div>

      {/* Warning/Info Box */}
      <div className="text-xs text-left mt-6 bg-[#1a1033] p-4 rounded-lg border border-[#BD3193] sm:p-2 xs:p-1">
        <ol className="list-decimal pl-4 text-[#D88BEE] space-y-1 font-semibold">
          <li>GAMBLE RESPONSIBLY!</li>
          <li>18+ And Above.</li>
          <li>THIS GAME IS ONLY AVAILABLE FOR USERS IN NIGERIA.</li>
          <li>1 coin = 1 naira.</li>
          <li>
            Please select your payment method first before you want to recharge.
          </li>
        </ol>
      </div>
    </div>
  </Modal.Body>

  {/* Footer */}
  <Modal.Footer className="bg-[#130828] border-none flex justify-center">
    <button
      className="bg-[#BD3193] hover:bg-[#a0267a] text-white px-6 py-3 rounded-lg font-bold text-lg w-full max-w-xs sm:px-4 sm:py-2 xs:px-2 xs:py-1"
      onClick={() => initiateDeposit(selectedAmount * 100)}
    >
      Deposit
    </button>
  </Modal.Footer>
</Modal>


      {/* End Deposit Info Modal */}

      {/* Withdraw Info Modal */}
      <Modal
        show={showWithdrawInfo}
        onHide={closeWithdrawModal}
        fullscreen
        centered
        dialogClassName="bg-[#130828] custom-modal"
      >
        <Modal.Header closeButton className="bg-[#130828] border-none">
          <Modal.Title className="flex items-center justify-between w-full">
            <span className="text-white text-xl font-bold">Withdraw</span>
            <div className="flex items-center gap-2 bg-[#2E1243] rounded-full py-2 px-6 text-lg font-bold ml-4">
              <img src={Coin} alt="coin" className="w-5 h-5" />
              <span className="text-white">
                {(Math.round(user?.walletBalance) / 100).toLocaleString(
                  undefined,
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }
                )}
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-[#130828] text-white min-h-[70vh] flex flex-col items-center">
          <div className="w-full max-w-md px-4 sm:px-2 xs:px-1">
            <img
              src={ludo}
              alt="Ludo Classic"
              className="rounded-lg w-full mb-6"
            />
            <div className="grid grid-cols-3 gap-4 text-center sm:gap-2 xs:gap-1">
              {[100000, 50000, 20000, 10000, 5000, 2000, 1000, 500].map(
                (amount) => (
                  <div
                    key={amount}
                    className={`bg-[#1F0A35] border border-[#BD3193] rounded-xl px-2 py-4 font-semibold cursor-pointer ${
                      selectedWithdrawAmount === amount
                        ? "ring-2 ring-[#BD3193]"
                        : ""
                    } sm:px-1 sm:py-3 xs:px-0.5 xs:py-2`}
                    onClick={() => setSelectedWithdrawAmount(amount)}
                  >
                    <div className="flex items-center justify-center ">
                      <img src={Coin} alt="coin" className="w-5 h-5 inline-block align-middle mr-1" />
                      {amount.toLocaleString()}
                    </div>
                  </div>
                )
              )}
            </div>
            <div className="mt-6 text-center text-sm font-semibold">
              Bank Account:{" "}
              {user?.account_number
                ? maskAccountNumber(user.account_number)
                : "No bank account"}
              <span
                className="ml-2 text-[#BD3193] cursor-pointer"
                onClick={() => navigate("/user-profile/add-bank")}
              >
                ✏️
              </span>
            </div>
            <div className="text-[11px] mt-6 space-y-2 text-gray-300 text-center leading-relaxed px-2">
              <p>
                The amount you can withdraw is related to your total winnings
                and losses
              </p>
              <p>It may take up to 5 mins – 48 hours to withdraw</p>
              <p>
                If you have any problems with withdrawal, you can contact
                customer service
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="bg-[#130828] border-none flex justify-center">
          <button
            className="bg-[#BD3193] hover:bg-[#a0267a] text-white px-6 py-3 rounded-lg font-bold text-lg w-full max-w-xs sm:px-4 sm:py-2 xs:px-2 xs:py-1"
            onClick={() => {
              setShowWithdrawInfo(false); // Close new modal
              setWithdrawModal({
                visible: true,
                onHide: () =>
                  setWithdrawModal((m) => ({ ...m, visible: false })),
                size: "md",
                amount: selectedWithdrawAmount,
              });
            }}
          >
            Withdraw
          </button>
        </Modal.Footer>
      </Modal>
      {/* End Withdraw Info Modal */}

      <WithdrawModal modalProps={withdrawModal} />
      <ComingSoonModal
        show={showComingSoon}
        onHide={() => setShowComingSoon(false)}
        feature={comingSoonFeature}
      />
    </>
  );
}

function GamesGrid({ accountType }) {
  const { games, getGames, loading } = useGames();
  const navigate = useNavigate();
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [comingSoonFeature, setComingSoonFeature] = useState("");
  const handleGameSelect = (game) => {
    // Check if the game is Snooker or Ludo

    if (game.id === "Snooker" || game.id === "Ludo") {
      setComingSoonFeature(`${game.id} Game`);
      setShowComingSoon(true);
    } else {
      if (accountType === "celebrity") {
        navigate(`/celebrity/host/${game.id}`);
      } else {
        navigate(`/games/selected-game/${game.id}`);
      }
    }
  };

  useEffect(() => {
    const fetchGames = async () => {
      try {
        await getGames();
      } catch (error) {
        // console.error("Error fetching games:", error);
      }
    };
    fetchGames();
  }, []);

  return (
    <div className=" py-10">
      <div className="flex items-center justify-between mb-4">
        <span className="text-base text-white font-semibold">
          {accountType === "celebrity" ? "HOST GAME" : "AVAILABLE GAMES"}
        </span>
        <span
          className={`text-base font-medium cursor-pointer flex items-center gap-1 hover:underline ${
            accountType === "celebrity" ? "text-[#3F7227]" : "text-[#D88BEE] "
          }`}
          onClick={() => navigate("/games")}
        >
          See all <CustomSvg name="arrow-right" width={16} height={16} />
        </span>
      </div>

      <div className="flex overflow-x-auto gap-4 scroll-smooth snap-x snap-mandatory no-scrollbar">
        {loading ? (
          <div className="text-white">Loading...</div>
        ) : (
          games.slice(0, 5).map((game, index) => {
            const color = bgColors[index % bgColors.length];

            return (
              <div
                key={game.id}
                onClick={() => handleGameSelect(game)}
                className={`flex-shrink-0 snap-start cursor-pointer w-[150px] rounded-xl p-3 shadow-md hover:shadow-lg transition ${color}`}
              >
                <div className="mb-3 overflow-hidden rounded-lg bg-black/10">
                  <img
                    src={game.img}
                    alt={game.title}
                    className="w-full h-24 object-cover rounded-lg"
                  />
                </div>

                <div className="flex flex-row justify-between items-center">
                  <div className="mb-2">
                    <div className="text-white font-semibold text-sm truncate">
                      {game.title}
                    </div>
                    <div className="text-white/80 text-xs truncate">
                      {game.caption?.split(" ").slice(0, 2).join(" ")}
                    </div>
                  </div>

                  <div className="flex justify-end">
                    <CustomSvg
                      name="arrow-right"
                      color="#fff"
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      <ComingSoonModal
        show={showComingSoon}
        onHide={() => setShowComingSoon(false)}
        feature={comingSoonFeature}
      />
    </div>
  );
}

function TopGamers({ accountType }) {
  const navigate = useNavigate();
  const [topGamers, setTopGamers] = useState([]);
  const [loading, setLoading] = useState(true);
  const userContext = useContext(UserContext); // Use the same context as AllUsers.jsx

  useEffect(() => {
    const fetchTopGamers = async () => {
      try {
        const response = await getRequest("/top/gamers");
        if (response?.data) {
          setTopGamers(response.data);
        }
      } catch (error) {
        // console.error("Error fetching top gamers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopGamers();
  }, []);

  const handleGamerClick = (user) => {
    navigate("/chat", {
      state: {
        selectedUser: {
          _id: user.userInfo._id,
          name: user.userInfo.username,
          avatar: user.userInfo.avatar || user.userInfo.profile,
          username: user.userInfo.username,
        },
      },
    });
  };

  return (
    <div className="dashboard-section pb-5">
      <div className="flex justify-between items-center mb-4">
        <span className="text-base text-white font-semibold">
          {accountType === "celebrity" ? "TOP WINNERS" : "TOP GAMERS"}
        </span>

        <span
          className={`cursor-pointer flex items-center gap-1 ${
            accountType === "celebrity" ? "text-[#3F7227]" : "text-[#D88BEE] "
          }`}
          onClick={() => navigate("/all-users")}
        >
          See all <CustomSvg name="arrow-right" width={16} height={16} />
        </span>
      </div>

      <div className="flex overflow-x-auto  gap-4 pb-2 scrollbar-hide">
        {loading ? (
          <div className="text-center w-full">Loading...</div>
        ) : (
          topGamers.slice(0, 5).map((user) => (
            <div
              key={user._id}
              className="flex flex-col items-center min-w-[80px] cursor-pointer"
              onClick={() => handleGamerClick(user)}
            >
              <img
                src={user?.userInfo?.avatar || user?.userInfo?.profile || avatar}
                alt={user.userInfo.username}
                className={`w-16 h-16 rounded-full object-cover border-2  ${
                  accountType === "celebrity"
                    ? "border-[#3F7227]"
                    : "border-[#BE3593]"
                }`}
              />
              <div className="mt-2 text-sm font-medium text-gray-200 truncate w-full text-center">
                {user.userInfo.username.slice(0, 6)}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

function BottomNav({ accountType }) {
  const navigate = useNavigate();
  // Use react-icons for all icons in the bottom nav
  // mail: IoMdNotifications, trophy: FaTrophy, lobby: HiUsers, profile: LuUser
  return (
    <div
      className={`dashboard-bottom-nav ${
        accountType === "celebrity" ? "bg-[#3F7227]" : "bg-[#BE3593]"
      }`}
    >
      <button
        className="dashboard-bottom-nav__btn"
        onClick={() => navigate("/chat")}
        aria-label="Chat"
      >
        <IoChatbubble color="#fff" size={22} />
      </button>
      <button
        className="dashboard-bottom-nav__btn"
        onClick={() =>
          navigate(
            accountType === "celebrity"
              ? "/celebrity/tournaments"
              : "/tournaments"
          )
        }
        aria-label="Tournaments"
      >
        <FaTrophy color="#fff" size={22} />
      </button>
      {/* Show My Lobbies only if not celebrity */}
      {accountType !== "celebrity" && (
        <button
          className="dashboard-bottom-nav__btn"
          onClick={() => navigate("/games/my-lobbies")}
          aria-label="My Lobbies"
        >
          <HiUsers color="#fff" size={22} />
        </button>
      )}
      <button
        className="dashboard-bottom-nav__btn"
        onClick={() => navigate("/user-profile/user")}
        aria-label="Profile"
      >
        <LuUser color="#fff" size={22} />
      </button>
    </div>
  );
}

function Dashboard({ accountType }) {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [isLeftBlockOpen, setIsLeftBlockOpen] = useState(true);
  const [isRightBlockOpen, setIsRightBlockOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState("both");
  const [isMobile, setIsMobile] = useState(false);

  // Game result modal state
  const [showResultModal, setShowResultModal] = useState(false);
  const [gameResult, setGameResult] = useState(null);
  const [stakeAmount, setStakeAmount] = useState(0);
  const [showRating, setShowRating] = useState(false);

  useEffect(() => {
    const savedResult = localStorage.getItem("gameResult");
    if (savedResult) {
      try {
        const result = JSON.parse(savedResult);
        // Always set playerId from user context if available
        if (user && user._id) {
          result.playerId = user._id;
        }
        setGameResult(result);
        setStakeAmount(result.stakeAmount || 0);
        setShowResultModal(true);
      } catch (e) {
        localStorage.removeItem("gameResult");
      }
    }
  }, [user]);

  const userLogout = () => {
    sessionStorage.removeItem("token");
    navigate("/login");
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isLeftBlockOpen && isRightBlockOpen) {
      setBlocksOpen("both");
    } else if (!isLeftBlockOpen && !isRightBlockOpen) {
      setBlocksOpen("none");
    } else {
      setBlocksOpen("one");
    }
  }, [isLeftBlockOpen, isRightBlockOpen]);

  if (isMobile) {
    return (
      <div className="dashboard dashboard--mobile p-3">
        {showResultModal && gameResult && (
          <GameResultModal
            open={showResultModal}
            onClose={() => {
              setShowResultModal(false);
              localStorage.removeItem("gameResult");
              setShowRating(true);
            }}
            result={gameResult}
            stakeAmount={stakeAmount}
          />
        )}
        {showRating && <GameRating onClose={() => setShowRating(false)} />}
        <MobileHeader
          user={user}
          userLogout={userLogout}
          accountType={accountType}
        />
        <BalanceCard user={user} accountType={accountType} />
        <GamesGrid accountType={accountType} />
        <TopGamers accountType={accountType} />
        <BottomNav accountType={accountType} />
      </div>
    );
  }

  const getMainContentClass = () => {
    const baseClass = "dashboard__main-content";
    switch (blocksOpen) {
      case "both":
        return `${baseClass} dashboard__main-content--both-open`;
      case "one":
        return `${baseClass} dashboard__main-content--one-open`;
      case "none":
        return `${baseClass} dashboard__main-content--none-open`;
      default:
        return baseClass;
    }
  };

  return (
    <div className="dashboard">
      {showResultModal && gameResult && (
        <GameResultModal
          open={showResultModal}
          onClose={() => {
            setShowResultModal(false);
            localStorage.removeItem("gameResult");
            setShowRating(true);
          }}
          result={gameResult}
          stakeAmount={stakeAmount}
        />
      )}
      {showRating && <GameRating onClose={() => setShowRating(false)} />}
      <DashboardHeader />
      <div className="dashboard__container">
        {/* Mobile Controls */}
        <div className="dashboard__mobile-controls d-lg-none d-md-none d-flex">
          <div className="col-6">
            <CollapseBlock isSmallScreen={true} />
          </div>
          <div className="col-6">
            <CollapseBlockRight isSmallScreen={true} />
          </div>
        </div>

        {/* Left Sidebar */}
        <div
          className={`dashboard__sidebar dashboard__sidebar--left d-lg-flex d-md-flex d-none ${
            isLeftBlockOpen ? "expanded" : ""
          }`}
        >
          <CollapseBlock setIsLeftBlockOpen={setIsLeftBlockOpen} />
        </div>

        {/* Main Content */}
        <div className={getMainContentClass()}>
          <DashboardHero
            isLeftBlockOpen={isLeftBlockOpen}
            isRightBlockOpen={isRightBlockOpen}
          />
        </div>

        {/* Right Sidebar */}
        <div
          className={`dashboard__sidebar dashboard__sidebar--right d-lg-flex d-md-flex d-none ${
            isRightBlockOpen ? "expanded" : ""
          }`}
        >
          <CollapseBlockRight setIsRightBlockOpen={setIsRightBlockOpen} />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;

// mt-lg-4 mt-md-4 mt-4 px-lg-4 px-md-4 px-4 justify-content-between
